<div class="responsible-selection">
    <div>
        <div class="dialog-heading">
            <h2 id="dimension-responsible-title" class="section-title m-0">
                {{ 'advancedMeasure.responsable.modalTitle' | translate }}
            </h2>
            <p-button
                icon="ms ms-close"
                severity="secondary"
                [text]="true"
                [rounded]="true"
                [ariaLabel]="'common.close_button' | translate"
                (onClick)="onCancel()" />
        </div>
        <p-select
            [options]="config.data.responsableOptions"
            [(ngModel)]="config.data.selectedResponsable"
            optionLabel="label"
            optionValue="value"
            [placeholder]="'advancedMeasure.responsable.placeholder' | translate"
            [showClear]="true"
            ariaLabelledBy="dimension-responsible-title"
            class="w-full" />
    </div>
    <div class="form-actions">
        <p-button severity="secondary" [label]="'common.cancel_button' | translate" (onClick)="onCancel()" />
        <p-button [label]="'common.confirm_button' | translate" (onClick)="onSubmit()" />
    </div>
</div>
